export const LocalStorageKeys = {
  LOGIN_STATUS: 'loginStatus',
  CODE_VERIFIER: 'code_verifier',
  SAVED_WISH_LIST_PRODUCTS: 'savedWishListProduct',
};

export default LocalStorageKeys;
